import RequestTableRow_vue_vue_type_script_setup_true_lang_default from "./RequestTableRow.vue.script.js";
//#region src/v2/blocks/request-block/components/RequestTableRow.vue
var RequestTableRow_default = RequestTableRow_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { RequestTableRow_default as default };

//# sourceMappingURL=RequestTableRow.vue.js.map